// Échelle d'affichage (accessibilité malvoyance) : agrandit texte, contrôles
// et espacements en jouant sur la taille de police RACINE (rem) — appliquée
// via data-ak-v2-scale sur <html> (règles en fin de tailwind.css). Toute
// l'application en bénéficie, interface classique comprise.
//
// « Normale » n'a pas la même taille partout : la V2 s'affiche à 90 % (règle
// `html:has(…)` de tailwind.css, équivalent d'un zoom navigateur à 90 %),
// l'interface classique à 100 %. « Grande » et « Très grande » gardent leurs
// tailles absolues (112,5 % et 125 %) dans les deux interfaces. Pour que tout
// suive, les dimensions de composition V2 s'écrivent en rem, jamais en px
// (verrouillé par uiScale.test.js).
const STORAGE_KEY = "akV2UiScale";

export const UI_SCALE_OPTIONS = Object.freeze(["normal", "large", "xlarge"]);
export const DEFAULT_UI_SCALE = "normal";

const root = () => (typeof document !== "undefined" ? document.documentElement : null);

export const readStoredUiScale = () => {
  try {
    const value = typeof window !== "undefined" ? window.localStorage?.getItem?.(STORAGE_KEY) : null;
    return UI_SCALE_OPTIONS.includes(value) ? value : DEFAULT_UI_SCALE;
  } catch (_) {
    return DEFAULT_UI_SCALE;
  }
};

export const applyUiScale = (scale, target = root()) => {
  const resolved = UI_SCALE_OPTIONS.includes(scale) ? scale : DEFAULT_UI_SCALE;
  if (!target) return resolved;
  if (resolved === DEFAULT_UI_SCALE) target.removeAttribute("data-ak-v2-scale");
  else target.setAttribute("data-ak-v2-scale", resolved);
  return resolved;
};

export const currentUiScale = (target = root()) => {
  const value = target ? target.getAttribute("data-ak-v2-scale") : null;
  return UI_SCALE_OPTIONS.includes(value) ? value : DEFAULT_UI_SCALE;
};

export const selectUiScale = (scale) => {
  const applied = applyUiScale(scale);
  try {
    if (applied === DEFAULT_UI_SCALE) window.localStorage?.removeItem?.(STORAGE_KEY);
    else window.localStorage?.setItem?.(STORAGE_KEY, applied);
  } catch (_) {
    // Stockage indisponible : l'échelle vaut pour la session courante.
  }
  return applied;
};

export const bootUiScale = () => applyUiScale(readStoredUiScale());
